<template>
  <div class="content">
    <heads :msg="pageTitle"></heads>
    <div v-show="showLoading" class="div_loading">
      <van-loading type="spinner" size="24px" />
    </div>
    <div v-show="!showLoading" style="padding-bottom: 72px">
      <!--评测-->
      <div v-show="!showProgress" class="page_content">
        <p class="p_title">{{ courseware_title }}</p>
        <p v-if="answer_type==3" class="p_date_tip">{{ startTime + "~" + endTime }} </p>
        <div class="testMsg" :class="answer_type !==3 ?'testMsg_margin':''">
          <div class="testItem">
            <p class="redWord">{{ question_count }}</p>
            <p class="p_des">道题</p>
          </div>
          <span class="line"></span>
          <div class="testItem">
            <p class="redWord">{{ Math.floor(exam_score) }}</p>
            <p class="p_des">分</p>
          </div>
          <span class="line"></span>
          <div class="testItem">
            <p class="redWord">{{ duration }}</p>
            <p class="p_des">分钟</p>
          </div>
        </div>
        <span class="btn" :class="btnIsRed ? 'noEnd' : 'end'" @click="beginExam">
          {{ btnText }}
        </span>
      </div>
      <!--进度条-->
      <div v-show="showProgress" class="page_content">
        <p v-if="is_end==-1" class="title_tip">您还未做过该练习</p>
        <p v-else-if="is_end==0" class="title_tip">您的上次练习还有做完，是否继续做题？</p>
        <!-- <p v-else v-show="source_type!=3" class="title_tip">恭喜你~你已超过<span style="color: #ee2e2e">{{ beyond }}</span>的学员，要继续努力呀</p> -->
        <p v-else v-show="source_type!=3" class="title_tip">恭喜您已完成练习，要继续努力呀</p>
        <div class="progress">
          <div id="myChart" class="chart"></div>
          <div class="progress_info">
            <span class="rate">
              <span class="big">{{ correct_rate }}</span>
              <span v-if="answer_type == 1" class="small">%</span>
              <span v-else class="small">分</span>
            </span>
            <p v-if="answer_type == 1" class="p_text">正确率</p>
            <p v-else class="p_text">满分{{ Math.floor(exam_score) }}分</p>
            <hr class="line">
            <p class="count">共{{ question_count }}题</p>
          </div>
        </div>

        <div v-if="del_exercise_num > 0 || new_exercise_num > 0" class="tips_box">
          <p>该试卷发生了变化<span v-if="new_exercise_num > 0">，新增了{{ new_exercise_num }}道试题</span><span v-if="del_exercise_num > 0">，删除了{{ del_exercise_num }}道试题</span></p>
          <span class="tip_arrow"></span>
        </div>



        <div class="div_btn">
          <!--实心红色 btn_look-->
          <span v-show="showBtnCxks" class="btn_look" @click="doReStart">重新开始</span>
          <span v-show="showBtnKslx" class="btn_look" @click="doStart">开始练习</span>
          <span v-show="showBtnCkjx" class="btn_look" @click="doLookAnswer">查看解析</span>
          <span v-show="showBtnJxzt" class="btn_try_agin" @click="doContinue">继续做题</span>
          <!--空心红边 btn_try_agin-->
          <span v-show="showBtnCzct" class="btn_try_agin" @click="doWrongAgin">重做错题</span>
          <span v-show="showBtnZlyc" class="btn_try_agin" @click="doOnceMore">再来一次</span>
          <span v-show="showBtnZlyz" class="btn_try_agin" @click="dOnceAgin">再来一组</span>
          <span v-show="showBtnCkbg && smsUrl.length > 0" class="btn_try_agin" @click="getReport">{{ answer_type == 2 || answer_type == 4 ? "领取报告" : "查看报告" }}</span>
          <span v-show="showBtnJsing" class="btn_round_gray">竞赛结束后可查看</span>
        </div>
      </div>
      <!--答题卡-->
      <div v-show="showCard && wrongsList.length >0" class="div_card">
        <div class="line" />
        <p class="card_title">答题卡</p>
        <div class="card_item">
          <span v-for="(item, index) in wrongsList" :key="index" class="span_item" :class="item.correct == 0 ? 'span_item_red' : item.correct == 1 ? 'span_item_green':''">{{ index+1 }}</span>
        </div>
      </div>
      <!--知识点列表-->
      <div v-show="!showPhb && coursewareList.length>0" class="div_knowledge">
        <p class="p_tip">
          <span class="line" />
          <span style="margin: 0px 16px">您在下列知识点的掌握情况</span>
          <span class="line" />
        </p>
        <div v-for="(item, index) in coursewareList" :key="index" class="knowledge_item">
          <div class="left">
            <span class="sp_circle" />
            <span class="sp_title">{{ item.title }}</span>
          </div>
          <van-circle v-model="item.accomplish" :rate="item.accomplish" layer-color="#cccccc" color="#ee2e2e" size="35" :text="item.text" />
        </div>
      </div>
      <!--排行榜-->
      <div v-show="showPhb" class="div_ph">
        <div class="line" />
        <p class="p_phb"><span>排行榜</span></p>
        <div v-show="myPhInfo.index" class="my_ph_info">
          <p class="p_tip">您的当前排名为&nbsp;&nbsp;<span class="sp_red">{{ myPhInfo.index }}</span></p>
          <p class="p_tip">得分：<span class="sp_re2">{{ myPhInfo.score }}</span>分</p>
        </div>
        <div v-for="(item, index) in phbList" :key="index" class="knowledge_item">
          <div class="left">
            <img v-if="index==0" class="iv_icon" src="@/assets/phb/one.png">
            <img v-else-if="index==1" class="iv_icon" src="@/assets/phb/two.png">
            <img v-else-if="index==2" class="iv_icon" src="@/assets/phb/three.png">
            <span v-else :key="index" class="span_item">{{ index+1 }}</span>
            <span class="name">{{ item.user_name }}</span>
          </div>
          <p class="p_tip">得分：<span class="sp_re2">{{ item.score }}</span>分</p>
        </div>
        <div v-show="phbList.length<=0" class="div_empty">
          <img class="iv_empty" src="@/assets/phb/empty.png">
          <p>暂无排行~</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBrushHome, getAnswerResult, getAnswerKnowledge, getLastAnswer, getRankList } from '@/api/zkbproEdu.js'

export default {
  components: {
  },
  data() {
    return {
      courseware_title: '',
      // 进度
      beyond: '0%',
      correct_rate: 0,
      progress: 0,
      curr: '0',
      // duration  时长  'question_count 试题数量  exam_score 总分
      duration: 0,
      question_count: 0,
      exam_score: 0,
      // 时间
      startTime: '',
      endTime: '',
      wrongsList: [],
      phbList: [],
      myPhInfo: {},
      coursewareList: [],
      // 盒子显示开关
      showProgress: true,
      showPhb: false,
      showCard: false,
      // 进度条盒子按钮显示开关
      showBtnKslx: false,
      showBtnCkjx: false,
      showBtnCzct: false,
      showBtnCkbg: false,
      showBtnZlyc: false,
      showBtnZlyz: false,
      showBtnCxks: false,
      showBtnJxzt: false,
      showBtnJsing: false,
      // 分数盒子按钮文案
      btnText: '开始做题',
      btnIsRed: true,
      currentRate: 100,
      answer_type: 1,
      is_end: -1,
      showLoading: true,
      pageTitle: '练习报告',
      courseware_id: '',
      courseware_type: '',
      schedule_id: '',
      result_id: '',
      lesson_id: '',
      class_id: '',
      review_id: '', // 做题id
      smsUrl: '', // 领取报告的url
      // 新参数
      source_id: this.$route.query.source_id,
      source_type: this.$route.query.source_type, // 3智能刷题
      answer_id: this.$route.query.answer_id,
      del_exercise_num: 0, // 删除习题数量
      new_exercise_num: 0 // 新增试题数量
    }
  },
  mounted() {
    this.initParams()
    if (this.answer_id) {
      this.getResultInfo()
    } else {
      this.getPageInfo()
    }
  },
  methods: {
    // 初始化参数
    initParams() {
      this.lesson_id = this.$route.query.lesson_id || ''
      this.schedule_id = this.$route.query.schedule_id || ''
      this.class_id = this.$route.query.class_id || ''
      // 有值是结果页 默认是开始页
      // this.result_id = this.$route.query.result_id
      // 是否做完了
      this.is_end = this.$route.query.is_exercise_end || '-1'
      // 新参数
      this.source_id = this.$route.query.source_id
      // source_type：1、随堂练习 2、评测 3、智能刷题  5、错题
      this.source_type = this.$route.query.source_type
      this.answer_id = this.$route.query.answer_id
    },
    doStart() {
      // 开始练习
      const info = {
        source_id: this.source_id,
        source_type: this.source_type,
        lesson_id: this.lesson_id,
        schedule_id: this.schedule_id,
        class_id: this.class_id
      }
      this.unitPushExercisePage(info)
    },
    doLookAnswer() {
      // 查看解析
      const info = {
        source_id: this.source_id, // 章节：错题的查看解析，已消灭错题的解析
        answer_id: this.answer_id,
        source_type: this.source_type,
        lesson_id: this.lesson_id,
        class_id: this.class_id
      }
      this.unitPushAnalysisPage(info)
    },
    doContinue() {
      // 继续做题
      const info = {
        is_retain: 1,
        answer_id: this.answer_id,
        source_id: this.source_id,
        source_type: this.source_type,
        lesson_id: this.lesson_id,
        schedule_id: this.schedule_id,
        class_id: this.class_id
      }
      this.unitPushExercisePage(info)
    },
    doWrongAgin() {
      // 重做错题
      // is_error: 1
      var source_type = 6
      const info = {
        source_id: this.answer_id,
        source_type: source_type,
        lesson_id: this.lesson_id,
        schedule_id: this.schedule_id,
        class_id: this.class_id
      }
      this.unitPushExercisePage(info)
    },
    doOnceMore() {
      // 再来一次
      this.doStart()
    },
    doReStart() {
      // 重新开始
      this.doStart()
    },
    dOnceAgin() {
      // 再来一组 【智能刷题】
      this.doStart()
    },
    getReport() {
      // 查看报告  领取报告
      window.location.href = this.smsUrl
    },
    beginExam() {
      // 开始考试
      if (this.btnIsRed) {
        this.doStart()
      } else {
        this.$toast(this.btnText)
      }
    },
    // 统一去做题页
    unitPushExercisePage(info) {
      console.log(info)
      // 先移除记录数据
      sessionStorage.removeItem('paperLists')
      this.$router.push({
        path: '/exerciseMode',
        query: info
      })
    },
    // 统一去解析页面
    unitPushAnalysisPage(info) {
      this.$router.push({
        path: '/analysis',
        query: info
      })
    },
    // 获取结果页
    getResultInfo() {
      const params = {
        answer_id: this.answer_id
      }
      getAnswerResult(params).then(res => {
        this.showLoading = false
        if (res.errNo == 0) {
          const result = res.result

          // 考试名称
          this.courseware_title = result.answer_name || ''

          this.beyond = result.beyond || '0%'
          // 领取报告url
          this.smsUrl = result.sms || ''
          // 考试id
          this.review_id = result.exam_id || '0'
          // 进度条
          // 1、随堂练习
          // 2、固定时间考试
          // 3、竞赛模式
          // 分数
          // 4、随到随考模式
          // 5、随堂评测模式
          this.answer_type = result.answer_type
          if (result.answer_type == 1) {
            this.correct_rate = result.correct_rate
          } else {
            this.correct_rate = result.score
          }
          this.progress = result.correct_rate

          this.del_exercise_num = parseInt(result.del_exercise_num || '0') || 0 // 删除习题数量
          this.new_exercise_num = parseInt(result.new_exercise_num || '0') || 0 // 新增试题数量

          // 是结果页的
          this.doResult(result, true)
        } else {
          this.$toast(res.msg)
        }
        this.$nextTick(() => {
          this.makeEchart()
        })
      })
    },
    // 渲染页面 按钮等
    doResult(result, isResult) {
      // 进度条
      // 1、随堂练习
      // 2、固定时间考试
      // 3、竞赛模式
      // 分数
      // 4、随到随考模式
      // 5、随堂评测模式
      this.courseware_title = result.answer_name || ''
      if (this.courseware_title && this.courseware_title.length > 0) {
        this.pageTitle = this.courseware_title
      }
      this.answer_type = result.answer_type
      // this.source_type = result.source_type
      this.exam_score = result.answer_score || 0
      // 题总数
      this.question_count = result.exercise_num ?? 0
      // 时长
      this.duration = result.answer_duration ?? 0
      // 进度条：9-未做题 10-没有错题 17-有错题（做完了）18-没做完继续做题 [随堂练习] 23 智能刷题报告页  24智能刷题继续做题
      // 排行榜： 27 随堂评测报告页30 随到随考练习报告页 35 竞赛模式结束页  36 竞赛模式未束页（结束后查看）41 固定考试结果
      // 分数：  25 随堂评测--开始页  28随到随考开始页  31 竞赛模式开始页 32 竞赛模式 开始页--时间已结束 33 竞赛模式 开始页--时间未开始 37 固定时间考试开始页 38 固定时间考试开始页 已结束 39 固定时间考试开始页 未开始
      // isend=-1 取retain   没开始 0 没做完 1做完了 [result_info取]
      // correct =1 绿色 0 红色
      // is end = -1 答题卡 灰色
      if (this.answer_id) {
        // 结果页
        if (this.answer_type == 5) {
          // 随堂评测
          if (this.is_end == -1) {
            // 未开始
            this.showProgress = false
            this.showPhb = true
            this.btnIsRed = true
            this.btnText = '开始做题'
          } else if (this.is_end == 0) {
            // 未做完
            this.showProgress = true
            this.showPhb = true
            this.showBtnCxks = true
            this.showBtnJxzt = true
          } else if (this.is_end == 1) {
            this.showProgress = true
            this.showPhb = true
            this.showBtnCkjx = true
            this.showBtnCzct = true
            this.showBtnZlyc = true
          }
          // 待确定
          // this.showBtnZlyc = true
        } else if (this.answer_type == 4) {
          // 随到随考
          this.showProgress = true
          this.showPhb = true
          this.showBtnCkbg = true
        } else if (this.answer_type == 3 || this.answer_type == 2) {
          // 3：竞赛模式 || 2： 固定模式
          this.showPhb = true
          this.showProgress = true
          if (result.answer_start_time && result.answer_start_time !== undefined) {
            this.startTime = result.answer_start_time
          }
          if (result.answer_end_time && result.answer_end_time !== undefined) {
            this.endTime = result.answer_end_time
            const time_end = this.get_unix_time(this.endTime)
            var time = Date.now()
            if (time > time_end) {
              if (this.answer_type == 3) {
                // 竞赛模式
                this.showBtnCkbg = true
              }
              this.showBtnCkjx = true
              this.showBtnCzct = true
            } else {
              this.showBtnJsing = true
            }
          }
        } else {
          this.showProgress = true
          this.showPhb = false
          // 题
          if (result.list) {
            this.wrongsList = result.list
          }
          if (this.is_end == -1) {
            // 未开始
            this.showBtnKslx = true
          } else if (this.is_end == 0) {
            // 没做完[您的上次联系还有未做完的，是否继续做题]
            this.showBtnCxks = true
            this.showBtnJxzt = true
            this.showCard = true
            console.log('isend0-1:' + this.is_end + 'showBtnZlyz:' + this.showBtnZlyz)
          } else {
            // 做完了
            // error_num  这个有值并且大于0，就是有错题，显示重做错题按钮 @曹林星
            if (this.source_type == 3) {
              // 智能刷题[再来一组]
              this.showBtnZlyz = true
              this.showBtnCkjx = true
            } else {
              this.showBtnZlyc = true
              if (result.error_num > 0) {
                this.showBtnCzct = true
              }
              this.showBtnCkjx = true
            }
            this.showCard = true
          }
        }
      } else {
        // 开始页
        this.is_end = result.finish ?? -1
        if (this.answer_type == 5) {
          // 随堂评测
          if (this.is_end == -1) {
            // 未开始
            // 做完了
            this.showProgress = false
            this.showPhb = true
            this.btnIsRed = true
            this.btnText = '开始做题'
          } else if (this.is_end == 0) {
            // 未做完
            this.showProgress = true
            this.showPhb = true
            this.showBtnCxks = true
            this.showBtnJxzt = true
          } else if (this.is_end == 1) {
            this.showProgress = true
            this.showPhb = true
            this.showBtnCkjx = true
            this.showBtnCzct = true
            this.showBtnZlyc = true
          }
        } else if (this.answer_type == 4) {
          // 随到随考
          this.showProgress = false
          this.showPhb = true
          this.showBtnCkbg = true
        } else if (this.answer_type == 3 || this.answer_type == 2) {
          // 竞赛模式
          this.showPhb = true
          this.showProgress = false
          if (result.answer_start_time && result.answer_start_time !== undefined) {
            this.startTime = result.answer_start_time
          }
          if (result.answer_end_time && result.answer_end_time !== undefined) {
            this.endTime = result.answer_end_time
          }
          if (this.endTime.length > 0 && this.startTime.length > 0) {
            const time_start = this.get_unix_time(this.startTime)
            const time_end = this.get_unix_time(this.endTime)
            const time = Date.now()
            console.log(time_start + '----' + time_end + '---' + time)
            if (time < time_start) {
              this.btnText = '考试时间未开始'
              this.btnIsRed = false
            } else if (time > time_end) {
              this.btnText = '考试时间已结束'
              this.btnIsRed = false
            } else {
              this.btnIsRed = true
              this.btnText = '开始做题'
            }
          }
        } else {
          // answer_type =1
          this.showProgress = true
          this.showPhb = false
          if (this.is_end == -1) {
            // 未开始
            this.showBtnKslx = true
            if (result.list) {
              this.wrongsList = result.list
            }
            if (this.source_type == 1 || this.source_type == 2) {
              this.showPhb = true
            }
          } else if (this.is_end == 0) {
            // 没做完[您的上次联系还有未做完的，是否继续做题]
            this.showBtnCxks = true
            this.showBtnJxzt = true
            this.showCard = true
            if (result.list) {
              this.wrongsList = result.list
            }
          } else if (this.is_end == 1) {
            // 做完了
            // error_num  这个有值并且大于0，就是有错题，显示重做错题按钮 @曹林星
            if (this.obj_type == 3) {
              // 智能刷题[再来一组]
              this.showBtnZlyz = true
              this.showBtnCxks = true
            } else {
              this.showBtnZlyc = true
              if (result.error_num > 0) {
                this.showBtnCzct = true
              }
              this.showBtnCkjx = true
            }
            this.showCard = true
            if (result.list) {
              const list = result.list || []
              this.wrongsList = list
            }
          }
        }
      }
      // 排行榜
      console.log('排行榜', this.showPhb)
      if (this.showPhb) {
        this.getPhbList()
      } else {
        // 知识点 重新请求接口
        if (this.answer_id && this.answer_id.length > 0) {
          this.getAnswerKnowledgeDatas(this.answer_id)
        }
      }
    },
    // 无answer_id 先请求接口获取到 answer_id 在请求接口
    getPageInfo() {
      const params = {
        source_id: this.source_id,
        source_type: this.source_type
      }
      getLastAnswer(params).then(res => {
        this.showLoading = false
        if (res.errNo == 0) {
          const result = res.result || {}
          const is_end = result.finish
          this.is_end = is_end
          if (is_end === -1) {
            // 没做过 --> 调另外的接口
            this.getPageInfo2(params)
            // 初始化圆圈
            this.correct_rate = 0
            this.progress = 0
            this.$nextTick(() => {
              this.makeEchart()
            })
          } else {
            const answer_id = result.answer_id || ''
            this.answer_id = answer_id
            this.getResultInfo()
            // 初始化圆圈
            this.$nextTick(() => {
              this.makeEchart()
            })
          }
        } else {
          this.$toast(res.msg)
        }
      })
    },
    // 获取基本信息
    getPageInfo2(info) {
      getBrushHome(info).then(res => {
        if (res.errNo == 0) {
          const result = res.result || {}
          this.doResult(result, false)
        }
      })
    },
    // 请求知识点掌握情况
    getAnswerKnowledgeDatas(answer_id) {
      getAnswerKnowledge({ answer_id: answer_id }).then(res => {
        if (res.errNo === 0) {
          const result = res.result || {}
          const list = result.list || []
          list.forEach(e => {
            e.accomplish = parseFloat(e.correct_rate ?? '0')
            e.text = e.correct_rate + '%'
          })
          this.coursewareList = list
        }
      })
    },
    // 展示排行榜
    getPhbList() {
      const params = {
        source_id: this.source_id,
        source_type: this.source_type
      }
      getRankList(params).then(res => {
        if (res.errNo == 0) {
          const result = res.result || {}
          const list = result.list || []
          const own = result.own || {}
          this.phbList = list
          if (own) {
            this.myPhInfo = own
          }
        } else {
          this.$toast(res.msg)
        }
      })
    },
    get_unix_time(dateStr) {
      var newstr = dateStr.replace(/-/g, '/')
      var date = new Date(newstr)
      var time_str = date.getTime().toString()
      return time_str.substr(0, 13)
    },
    // 进度条
    makeEchart() {
      var myChart = this.$echarts.init(document.getElementById('myChart'))
      myChart.resize({
        width: 'auto',
        height: 200
      })
      // 指定图表的配置项和数据
      var option = {
        angleAxis: {
          axisLine: {
            show: false
          },
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          min: 0,
          max: 124.5,
          boundaryGap: ['0', '100'],
          startAngle: 235
        },
        radiusAxis: {
          type: 'category',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          data: ['a', 'b', 'c'],
          z: 10
        },
        polar: {
          radius: '100%'
        },
        series: [
          {
            type: 'bar',
            data: [0, 0, this.progress],
            // data: [0, 0, this.exResultModel.rate],
            coordinateSystem: 'polar',
            // 圆环宽度
            barMaxWidth: 15,
            z: 2,
            roundCap: true,
            color: '#ee2e2e',
            barGap: '100%'

          },
          {
            type: 'bar',
            data: [0, 0, 100],
            z: 0,
            silent: true,
            coordinateSystem: 'polar',
            // 圆环宽度
            barMaxWidth: 15,
            name: 'C',
            roundCap: true,
            color: '#eee',
            barGap: '-100%'
          }

        ],
        tooltip: {
          show: false
        }
      }
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option)
      window.onresize = myChart.resize
    }
  }

}
</script>

<style lang="scss" scoped>
.div_loading {
  width: 32px;
  padding-top: 400px;
  margin: 0 auto;
}
/deep/.van-circle {
  .van-circle__text {
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #ee2e2e;
  }
}
.content {
  width: 100%;
  text-align: left;
  font-family: PingFangSC-Regular, PingFang SC;
}
.page_content {
  margin-top: 44px;
  text-align: center;
  .btn {
    display: inline-block;
    margin-top: 60px;
    margin-bottom: 76px;
    width: 600px;
    height: 90px;
    text-align: center;
    line-height: 90px;
    font-family: PingFangSC-Medium;
    font-size: 34px;
    color: #ffffff;
    font-weight: 500;
    border-radius: 4px;
  }
  .noEnd {
    background: #ee2e2e;
  }
  .end {
    background: #d7d6d6;
  }
  .p_date_tip {
    margin-bottom: 16px;
    margin-top: 16px;
    font-family: PingFangSC-Regular;
    font-size: 28px;
    text-align: center;
    color: #999999;
    font-weight: 400;
  }
  .p_title {
    font-family: PingFangSC-Medium;
    text-align: center;
    font-size: 38px;
    color: #333333;
    font-weight: 500;
  }
  .testMsg_margin {
    margin-top: 40px;
  }
  .testMsg {
    display: flex;
    justify-content: space-around;
    padding: 0px 96px;
    align-items: center;
    .p_des {
      font-family: PingFangSC-Regular;
      font-size: 35px;
      color: #999999;
      font-weight: 400;
    }
    .redWord {
      font-size: 68px;
      color: #ee2e2e;
      font-weight: 400;
    }
    .testItem {
      text-align: center;
      color: #999;
    }
    .line {
      width: 1.6px;
      height: 122px;
      background: #d8d8d8;
    }
  }
  .div_btn {
    width: 100%;
    text-align: center;
    padding-bottom: 56px;
    .btn_look {
      display: inline-block;
      width: 220px;
      height: 72px;
      line-height: 72px;
      margin-right: 12px;
      background: #ee2e2e;
      border-radius: 44px;
      text-align: center;
      font-family: PingFangSC-Medium;
      font-size: 32px;
      color: #ffffff;
      font-weight: 500;
    }
    .btn_try_agin {
      display: inline-block;
      width: 220px;
      height: 68px;
      line-height: 72px;
      margin-right: 12px;
      border-radius: 44px;
      border: 1px solid rgba(238, 46, 46, 1);
      text-align: center;
      font-family: PingFangSC-Medium;
      font-size: 32px;
      color: #ee2e2e;
      font-weight: 500;
    }
    .btn_round_gray {
      display: inline-block;
      width: 360px;
      height: 72px;
      line-height: 72px;
      margin-right: 12px;
      border-radius: 44px;
      border: 1px solid rgba(153, 153, 153, 1);
      text-align: center;
      font-family: PingFangSC-Medium;
      font-size: 32px;
      color: #ee2e2e;
      font-weight: 500;
    }
  }
  .title_tip {
    text-align: center;
    width: 100%;
    font-family: PingFangSC-Medium;
    font-size: 32px;
    color: #333333;
    line-height: 44px;
    font-weight: 500;
  }
  .progress {
    position: relative;
    background: #fff;
    margin-top: 120px;
    .progress_info {
      width: 100%;
      position: absolute;
      top: 22%;
      height: 240px;
      text-align: center;
      font-family: PingFangSC-Regular, PingFang SC;
      .rate {
        color: #ee2e2e;
        font-family: PingFangSC-Medium, PingFang SC;
        .big {
          font-size: 88px;
        }
        .small {
          font-size: 56px;
        }
      }
      .p_text {
        margin-top: 10px;
        color: #333333;
        font-size: 36px;
        margin-bottom: 15px;
      }
      .line {
        margin-block-start: 5px;
        margin-block-end: 5px;
        margin: 0 auto;
        width: 120px;
        color: #eeeeee;
        height: 1px;
        border: 0.5px solid #eeeeee;
        background-color: #eeeeee;
      }
      .count {
        margin-top: 10px;
        color: #999999;
        font-size: 28px;
      }
      .study_report {
        position: absolute;
        left: 50%;
        bottom: -80px;
        transform: translate(-50%);
        font-size: 26px;
        letter-spacing: 1px;
        color: #999999;
        padding-bottom: 20px;
        img {
          width: 32px;
          height: 32px;
          position: relative;
          top: 6px;
        }
      }
    }
  }
}
.div_card {
  .line {
    background: #eeeeee;
    width: 100%;
    height: 20px;
  }
  .card_title {
    margin: 30px 0px;
    font-family: PingFangSC-Medium;
    font-size: 32px;
    text-align: center;
    color: #333333;
    letter-spacing: 0;
    font-weight: 500;
  }
  .card_item {
    display: flex;
    padding-bottom: 30px;
    flex-wrap: wrap;
    .span_item_red {
      background: #ee2e2e !important;
    }
    .span_item_green {
      background: #54d32a !important;
    }
    .span_item {
      background: gray;
      display: inline-block;
      height: 72px;
      width: 72px;
      margin: 30px 38px;
      line-height: 72px;
      border-radius: 50%;
      font-family: PingFangSC-Regular;
      font-size: 36px;
      text-align: center;
      color: #ffffff;
      letter-spacing: 0;
      font-weight: 400;
    }
  }
}
.div_ph {
  .line {
    background: #eeeeee;
    width: 100%;
    height: 12px;
  }
  .p_tip {
    font-family: PingFangSC-Regular;
    font-size: 28px;
    color: #333333;
    line-height: 20px;
    font-weight: 400;
    .sp_red {
      font-family: PingFangSC-Regular;
      font-size: 28px;
      color: #ee2e2e;
      line-height: 20px;
      font-weight: 400;
    }
    .sp_re2 {
      display: inline-block;
      font-family: PingFangSC-Regular;
      text-align: left;
      width: 80px;
      font-size: 36px;
      color: #ee2e2e;
      line-height: 20px;
      font-weight: 400;
    }
  }
  .my_ph_info {
    margin: 14px 24px;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 20px 20px 35px;
    background: #f5f5f5;
  }
  .p_phb {
    height: 40px;
    line-height: 40px;
    margin-left: 26px;
    margin-top: 32px;
    margin-bottom: 14px;
    padding-left: 12px;
    margin-right: 8px;
    border-left: 8px solid #ee2e2e;
    font-family: PingFangSC-Medium;
    font-size: 36px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 500;
  }
  .knowledge_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 88px;
    line-height: 88px;
    padding: 14px 18px 14px 0px;
    margin-right: 26px;
    border-bottom: 1px solid #eeeeee;
    .left {
      display: flex;
      align-items: center;
      .name {
        font-family: PingFangSC-Medium;
        font-size: 28px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 500;
      }
      .iv_icon {
        width: 44px;
        height: 60px;
        margin: 30px 20px 30px 38px;
      }
      .span_item {
        background-color: #999999;
        display: inline-block;
        height: 48px;
        width: 48px;
        margin: 30px 20px 30px 38px;
        line-height: 48px;
        border-radius: 50%;
        font-family: PingFangSC-Regular;
        font-size: 28px;
        text-align: center;
        color: #ffffff;
        letter-spacing: 0;
        font-weight: 400;
      }
      .sp_circle {
        display: inline-block;
        height: 16px;
        width: 16px;
        margin-right: 16px;
        border-radius: 50%;
        background: #ee2e2e;
      }
      .sp_title {
        display: inline-block;
        width: 580px;
        font-size: 30px;
        color: #333333;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .div_empty {
    align-items: center;
    margin-top: 200px;
    padding: 40px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    .iv_empty {
      width: 200px;
      height: 200px;
    }
    p {
      margin-top: 40px;
      font-size: 28px;
      margin-left: 25px;
      color: #999999;
    }
  }
}
.div_knowledge {
  .p_tip {
    height: 76px;
    line-height: 76px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #666666;
    letter-spacing: 0;
    font-weight: 400;
    background: #f4f4f4;
    .line {
      display: inline-block;
      background: #c3c3c3;
      width: 146px;
      height: 2px;
    }
  }
  .knowledge_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 88px;
    line-height: 88px;
    padding: 14px 24px;
    .left {
      display: flex;
      align-items: center;
      .sp_circle {
        display: inline-block;
        height: 16px;
        width: 16px;
        margin-right: 16px;
        border-radius: 50%;
        background: #ee2e2e;
      }
      .sp_title {
        display: inline-block;
        width: 580px;
        font-size: 30px;
        color: #333333;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}

.tips_box {
  padding: 10px 15px;
  border: 1px solid #ccc;
  width: 400px;
  margin: 0 auto 20px;
  border-radius: 10px;
  position: relative;
  .tip_arrow {
    display: inline-block;
    width: 10px;
    height: 10px;
    position: absolute;
    left: calc(50% - 5px);
    top: -6px;
    box-sizing: border-box;
    border-left: 1px solid #ccc;
    border-top: 1px solid #ccc;
    transform: rotate(45deg);
    background-color: #fff;
  }
}
</style>
